import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';

export const getLetterPdf = httpsCallable(functions, 'getLetterPdf');
export const checkCongressPaymentMethod = httpsCallable(functions, 'checkCongressPaymentMethod');
export const createCongressSetupIntent = httpsCallable(functions, 'createCongressSetupIntent');
export const saveBillingAddress = httpsCallable(functions, 'saveBillingAddress');
export const lookupRepresentatives = httpsCallable(functions, 'lookupRepresentatives');
export const generateCongressLetter = httpsCallable(functions, 'generateCongressLetter');
export const reviseCongressLetter = httpsCallable(functions, 'reviseCongressLetter');
export const sendCongressLetter = httpsCallable(functions, 'sendCongressLetter');
export const previewCongressLetter = httpsCallable(functions, 'previewCongressLetter');
